import { useLocation } from 'react-router-dom';
import { isPreLoginAuthPath } from '../utils/isPreLoginAuthPath';

/**
 * Season end warnings/dialog only while logged in and past the login/auth screens.
 * @param {boolean} isLoggedIn
 * @returns {boolean}
 */
export function useSeasonUiEnabled(isLoggedIn) {
  const location = useLocation();
  if (!isLoggedIn) {
    return false;
  }
  return !isPreLoginAuthPath(location.pathname);
}

export default useSeasonUiEnabled;
